module.exports = __webpack_public_path__ + "img/logo_tesys.94aed6f7.png";